<div class="curtain" [class.open]="open">
  <div class="curtain-content">
    <!-- Left Side Menu -->
    <div class="left-menu">
      <button *ngFor="let menuItem of filteredMenuItems" class="menu-item" 
              [class.active]="selectedMenu === menuItem.id"
              (click)="selectMenu(menuItem.id)"
              [matTooltip]="menuItem.name" matTooltipClass="widgets-tooltip">
        <i [class]="'fa fa-' + menuItem.icon"></i>
        <span>{{ menuItem.name }}</span>
      </button>
    </div>

    <!-- Middle Content Area -->
    <div class="content-area">
      <!-- Layouts -->
      <div class="content-section" [class.active]="selectedMenu === 'layouts'">
        <div class="layouts-scroll-container">
          <button mat-raised-button (click)="lockGrid()"
                  class="layout-button"
                  [class.animate-in]="selectedMenu === 'layouts'"
                  [style.animation-delay]="selectedMenu === 'layouts' ? '0s' : '0s'"
                  [matTooltip]="gridLocked ? 'Unlock Grid' : 'Lock Grid'"
                  matTooltipClass="widgets-tooltip">
                  <mat-icon>{{ gridLocked ? 'lock_open' : 'lock' }}</mat-icon>
          </button>
          <button mat-raised-button (click)="privacyMode()"
                  class="layout-button"
                  [class.animate-in]="selectedMenu === 'layouts'"
                  [style.animation-delay]="selectedMenu === 'layouts' ? '0s' : '0s'"
                  [matTooltip]="'Privacy Mode'"
                  matTooltipClass="widgets-tooltip">
            <mat-icon>privacy_tip</mat-icon>
          </button>
          <button mat-raised-button (click)="applyDefaultLayout()"
                  (contextmenu)="onDefaultRightClick($event)"
                  class="layout-button"
                  [class.animate-in]="selectedMenu === 'layouts'"
                  [style.animation-delay]="selectedMenu === 'layouts' ? '0s' : '0s'"
                  [class.active]="!anyLayoutActive"
                  [matTooltip]="'Default Layout'"
                  matTooltipClass="widgets-tooltip">
            Default
          </button>

          <button *ngFor="let layout of widgetService.userLayouts; let i = index" mat-raised-button
                  (click)="selectLayout(layout)"
                  (contextmenu)="onRightClick($event, layout)"
                  class="layout-button"
                  [class.animate-in]="selectedMenu === 'layouts'"
                  [style.animation-delay]="selectedMenu === 'layouts' ? ((i + 1) * 0.1) + 's' : '0s'"
                  [class.active]="layout.isActive"
                  [matTooltip]="layout.name"
                  matTooltipClass="widgets-tooltip">
            {{ layout.name }}
          </button>

          <ng-container *ngIf="showAddInput">
            <input id="new-layout-input" class="add-layout-input"
                   type="text"
                   [(ngModel)]="newLayoutName"
                   placeholder="Layout name..."
                   (keyup.enter)="confirmAddLayout()"
                   (keyup.escape)="cancelAddLayout()"/>
            <button mat-icon-button class="add-layout-confirm" (click)="confirmAddLayout()">
              <mat-icon>check</mat-icon>
            </button>
            <button mat-icon-button class="add-layout-cancel" (click)="cancelAddLayout()">
              <mat-icon>close</mat-icon>
            </button>
          </ng-container>
          <button *ngIf="!showAddInput && layoutSettings?.allowCustomizeLayout" mat-raised-button 
                  (click)="addLayout()" 
                  class="layout-button" 
                  [class.animate-in]="selectedMenu === 'layouts'"
                  [style.animation-delay]="selectedMenu === 'layouts' ? ((widgetService?.userLayouts?.length + 1) * 0.1) + 's' : '0s'"
                  [matTooltip]="'Add New Layout'"
                  matTooltipClass="widgets-tooltip">
            <mat-icon>add</mat-icon>
          </button>
        </div>
      </div>

      <!-- Widgets -->
      <div class="content-section" [class.active]="selectedMenu === 'widgets'">
        <div class="widget-buttons">
          <button *ngFor="let widget of widgetService.availableWidgets; let i = index" class="widget-button" 
                  [class.animate-in]="selectedMenu === 'widgets'"
                  [style.animation-delay]="selectedMenu === 'widgets' ? (i * 0.1) + 's' : '0s'"
                  (click)="addWidget(widget.id)" 
                  [matTooltip]="widget.title"
                  matTooltipClass="widgets-tooltip">
            <i [class]="'fa fa-' + widget.icon" *ngIf="widget.id !== 'ask-ramsys'"></i>
            <img src="assets/images/chaticon.svg" alt="Chat Icon" *ngIf="widget.id === 'ask-ramsys'" />
          </button>
        </div>
      </div>      

      <!-- Themes Content -->
      <div class="content-section" [class.active]="selectedMenu === 'themes'">
        <div class="themes-container">
          <button *ngFor="let theme of themes; let i = index" class="theme-button" 
                  [class.animate-in]="selectedMenu === 'themes'"
                  [style.animation-delay]="selectedMenu === 'themes' ? (i * 0.1) + 's' : '0s'"
                  (click)="selectTheme(theme.id)"
                  [class.active]="selectedTheme === theme.id"
                  [matTooltip]="theme.name"
                  matTooltipClass="widgets-tooltip">
            <i [class]="'fa fa-' + theme.icon"></i>
            <span>{{ theme.name }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- General Error Message -->
    <div *ngIf="errorMessage" class="error-message">
      <i class="fa fa-exclamation warning-icon"></i>
      <span class="error-text">{{ errorMessage }}</span>
      <button class="error-close" (click)="clearErrorMessage()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <i class="fa fa-chevron-up" aria-hidden="true" (click)="toggleCurtain()"></i>
</div>

<!-- Context Menu -->
<div *ngIf="contextMenuVisible && layoutSettings?.allowCustomizeLayout"
     class="context-menu"
     [ngStyle]="{'top.px': contextMenuY, 'left.px': contextMenuX}"
     (mouseleave)="closeContextMenu()">
  <button (click)="deleteFromContextMenu()" class="context-menu-delete">
    <mat-icon>delete</mat-icon> Delete
  </button>
</div>

<div *ngIf="defaultContextMenuVisible && layoutSettings?.allowModifyDefaultLayout"
     class="context-menu"
     [ngStyle]="{'top.px': defaultContextMenuY, 'left.px': defaultContextMenuX}"
     (mouseleave)="closeDefaultContextMenu()">
    <button (click)="updateDefaultLayout()" class="context-menu-default">
      <mat-icon>edit</mat-icon> Update
    </button>
    <button (click)="resetDefaultLayout()" class="context-menu-default">
      <mat-icon>refresh</mat-icon> Reset
    </button>
</div>